<template>
  <div class="card card-1 p-5-px m-b-10">
     <h6>Search Filters</h6>
     <b-row>

       <b-col cols="6">
         <date-range-picker 
              v-model="filters.dateRange"
              :timePicker="false"
              :timePicker24Hour="true"
              class="datePicker"
              :locale-data="localeData"
               ref="picker"
               @update="filtersUpdated"
              >

              <!--    input slot (new slot syntax)-->
              <template #input="picker" style="min-width: 350px;">
                {{ picker.startDate | moment("dddd, MMMM Do YYYY") }} - {{ picker.endDate | moment("dddd, MMMM Do YYYY") }}
              </template>

              </date-range-picker>
       </b-col>

       <b-col cols="3">
          <b-form-input class="searchField" v-model="filters.orderNos" placeholder="Order nos. with prefix" @change="filtersUpdated"></b-form-input>
       </b-col>
       <b-col cols="3">
         <b-form-select v-model="filters.selectedStore" :options="stores"  @change="filtersUpdated"></b-form-select>
       </b-col>

       <b-col cols="3" class="m-t-20">
         <b-form-checkbox v-if="includeDryTest" v-model="filters.includeDry" name="check-button" switch @input="filtersUpdated">
            Include DRY Test 
        </b-form-checkbox>
       </b-col>
       <b-col cols="6"></b-col>
       <b-col cols="3" class="m-t-20">
          <a href="" @click.prevent="resetFilters" class="text-small float-right">Click to Reset Filters</a>
       </b-col>
     </b-row>
  </div>
</template>

<script>
import StoreService from '../../../services/store.service';
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import EventBus from '../../../EventBus';


  export default {
     props: {
       includeDryTest: {
         type: Boolean,
         default: true
       }
     },
     data(){

       let startDate = null;
       let endDate = null;  


       return {
         stores: [{
                value: null,
                text: 'Select a store'
              }],
         filters: {
            includeDry:false,
            orderNos: '',
            selectedStore: null,
            dateRange: {startDate, endDate},
         },
        localeData: {
          direction: 'ltr',
          format: 'mm/dd/yyyy',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          firstDay: 0
        }
       }
     },
     mounted(){
       this.fetchStores();
     },
     components: {DateRangePicker},
     methods: {
       fetchStores() {

      StoreService.fetchStores().then(response => {
              let company_stores = response.data.data.map(store => {
                return JSON.parse(JSON.stringify({
                  value: store.id,
                  text: store.identifier
                }))
              });
              this.stores = this.stores.concat(company_stores);
            })
            .catch(errors => console.log(errors));
        },
        filtersUpdated(){
           console.log('Filter Updated');

           EventBus.$emit('auto-drafts.filters-updated', this.filters)
        },
        resetFilters(){
           
           this.filters= {
                includeDry:false,
                orderNos: '',
                selectedStore: null,
                dateRange: {startDate: null, endDate: null},
            },
            this.filtersUpdated();


        }
     }
  }
</script>

<style lang="scss" scoped>
  .searchField{
    height: 37px;
    border-radius: 3px;
  }
</style>